import { IWorkflowTemplateVersionResponse } from '@commenda/types';
import { fetcher } from '@commenda/utils';
import { BASE_URL } from './helpers';

export const getWorkflowTemplateVersion = async (
  workflowTemplateVersionId: string
): Promise<{
  success: boolean;
  data: IWorkflowTemplateVersionResponse | null;
}> => {
  try {
    const res = await fetcher(
      `${BASE_URL}/version/${workflowTemplateVersionId}`,
      {
        method: 'GET',
      }
    );
    if (!res.ok) {
      return {
        success: false,
        data: null,
      };
    }
    return {
      success: true,
      data: (await res.json()) as IWorkflowTemplateVersionResponse,
    };
  } catch (error) {
    return {
      success: false,
      data: null,
    };
  }
};
